import { atom } from "recoil";
import * as Const from "@utils/Const";
// meun 
export const menu = atom({
    key: "menu",
    // key의 값은 항상 고유값이어야 합니다.
    default: null,
});
export const menuAdmin = atom({
    key: "menuAdmin",
    // key의 값은 항상 고유값이어야 합니다.
    default: null,
});
export const items = atom({
    key: "items",
    default: null
});
export const url = atom({
    key: "url",
    default: null
});
export const resets = atom({
    key: "resets",
    default: false
});
export const pages = atom({
    key: "pages",
    default: {
        "pageNum": 0,
        "size": 10,
        "totalElements": 0,
        "totalPages": 0,
    }
});
export const token = atom({
    key: "token",
    default: localStorage.getItem(Const.TOKEN)
});
